import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Use Vite base URL so the app works in any subfolder (e.g. /sessionboard/ or /app/)
const basename = (import.meta.env.BASE_URL ?? '/').replace(/\/+$/, '') || '/';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sessionboard/sw.js', { scope: '/sessionboard/' }).catch(() => {
      // Service worker registration failed
    });
  });
}
